// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as Utils$OrcaPaymentPage from "../../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../../Utilities/JotaiAtoms.bs.js";
import * as GenericInputField$OrcaPaymentPage from "./GenericInputField.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "../PaymentInputField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../../Utilities/DynamicFieldsUtils.bs.js";

function CardHolderNameField$FullNameFieldInput(props) {
  var lastNameFieldConfig = props.lastNameFieldConfig;
  var firstNameFieldConfig = props.firstNameFieldConfig;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var firstValidator = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(firstNameFieldConfig, localeString);
  var lastValidator = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(lastNameFieldConfig, localeString);
  var firstProps = ReactFinalForm.useField(firstNameFieldConfig.confirmRequestWritePath, {
        validate: firstValidator
      });
  var lastProps = ReactFinalForm.useField(lastNameFieldConfig.confirmRequestWritePath, {
        validate: lastValidator
      });
  var inputRef = React.useRef(null);
  var match$1 = React.useState(function () {
        var first = Core__Option.getOr(firstProps.input.value, "");
        var last = Core__Option.getOr(lastProps.input.value, "");
        return [
                    first,
                    last
                  ].filter(function (val) {
                      return val !== "";
                    }).join(" ");
      });
  var setName = match$1[1];
  var match$2 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(firstNameFieldConfig, localeString);
  var autocomplete = firstNameFieldConfig.htmlAutocompleteAttribute;
  var handleChange = function ($$event) {
    var value = $$event.target.value;
    setName(function (param) {
          return value;
        });
    var match = Utils$OrcaPaymentPage.splitFullName(value);
    firstProps.input.onChange(match[0]);
    lastProps.input.onChange(match[1]);
  };
  var handleBlur = function (_event) {
    firstProps.input.onBlur();
    lastProps.input.onBlur();
  };
  var handleFocus = function (_event) {
    firstProps.input.onFocus();
    lastProps.input.onFocus();
  };
  var active = firstProps.meta.active || lastProps.meta.active;
  var showError = (firstProps.meta.touched || firstProps.meta.submitFailed || lastProps.meta.touched || lastProps.meta.submitFailed) && !active;
  var allValid = firstProps.meta.valid && lastProps.meta.valid;
  var isValid = showError ? allValid : undefined;
  var errorString = showError && !allValid ? Core__Option.getOr(firstProps.meta.error, Core__Option.getOr(lastProps.meta.error, "")) : "";
  return React.createElement(PaymentInputField$OrcaPaymentPage.make, {
              isValid: Caml_option.some(isValid),
              value: match$1[0],
              onChange: handleChange,
              onBlur: handleBlur,
              errorString: errorString,
              onFocus: handleFocus,
              fieldName: match$2.label,
              name: DynamicFieldsUtils$OrcaPaymentPage.getFieldTestId(firstNameFieldConfig.confirmRequestWritePath),
              placeholder: match$2.placeholder,
              inputRef: inputRef,
              autocomplete: autocomplete
            });
}

var FullNameFieldInput = {
  make: CardHolderNameField$FullNameFieldInput
};

function CardHolderNameField(props) {
  var fields = props.fields;
  var firstNameField = fields[0];
  var lastNameField = fields[1];
  if (firstNameField !== undefined) {
    if (lastNameField !== undefined) {
      return React.createElement(CardHolderNameField$FullNameFieldInput, {
                  firstNameFieldConfig: firstNameField,
                  lastNameFieldConfig: lastNameField
                });
    } else {
      return React.createElement(GenericInputField$OrcaPaymentPage.make, {
                  fieldConfig: firstNameField
                });
    }
  } else if (lastNameField !== undefined) {
    return React.createElement(GenericInputField$OrcaPaymentPage.make, {
                fieldConfig: lastNameField
              });
  } else {
    return null;
  }
}

var make = CardHolderNameField;

export {
  FullNameFieldInput ,
  make ,
}
/* jotai Not a pure module */
